import axios from 'axios';

export default {
    fetchAll(includePrintersWithoutPaperType = false) {
        return axios.post('/printer/fetchAll', {
            includePrintersWithoutPaperType,
        });
    },

    fetchDebugData() {
        return axios.post('/printer/fetchDebugData');
    },

    fetchPapertypes() {
        return axios.post('/printer/fetchPapertypes');
    },

    batchUpdate(printers) {
        return axios.post('/printer/batchUpdate', {
            printers,
        });
    },
};
